import { getZeroMonetaryValue } from '../../../../utils/monetary-value-utils';
import { getItemModifierGroupById } from '../../../sales-data/selectors/items/get-item-modifier-group-by-id';
export const getInProgressItemModifierGroupsForItem = (item) => {
    return item.modifierGroups.map(getInProgressItemModifierGroup);
};
const getInProgressItemModifierGroup = (group) => {
    const modifierGroup = getItemModifierGroupById(group.itemModifierGroupId);
    if (!modifierGroup)
        throw new Error(`Cannot find modifier group with ID: ${group.itemModifierGroupId}`);
    const inProgressItemModifierGroup = {
        itemModifierGroupId: modifierGroup.id,
        selectedQuantity: 0,
        minimumReached: modifierGroup.quantityLimit.minimum === 0,
        maximumReached: false,
        maximumExceeded: false,
        modifiers: modifierGroup.modifiers.map(modifier => {
            return {
                itemId: modifier.itemId,
                quantity: 0,
                freeQuantity: 0,
                selectedPrice: modifier.prices[0],
                totalPrice: getZeroMonetaryValue(),
                totalSavings: getZeroMonetaryValue()
            };
        }),
        totalPrice: getZeroMonetaryValue(),
        totalSavings: getZeroMonetaryValue()
    };
    return inProgressItemModifierGroup;
};
